import { Loader } from '@assets/icons'
import React from 'react'

interface IProps {
    type?: 'button' | 'submit' | 'reset' | undefined
    onClick?: () => void
    placeholder: string
    secondary?: boolean
    isLoading?: boolean
    isDisabled?: boolean
    title?: string
    customClasses?: string
}

export default function Button(props: IProps): React.ReactElement {
    const { type, title, secondary, isDisabled, isLoading, placeholder, customClasses, onClick } = props

    return (
        <button
            type={type}
            title={title}
            onClick={onClick}
            disabled={isDisabled}
            className={
                secondary && !props.isDisabled ?
                    `button-secondary ${customClasses}`
                    : !secondary && !props.isDisabled ? `button-primary ${customClasses}` :
                        props.isDisabled ? 'isDisabled' : ''
            }
        >
            {!isLoading ? placeholder : <Loader style={{ width: '1rem' }} />}
        </button >
    )
}
